import { Pipe, PipeTransform } from "@angular/core";
import { SupportStatus } from "@models/support";

@Pipe({
  name: "supportStatus",
  standalone: true,
})
export class SupportStatusPipe implements PipeTransform {
  transform(value: SupportStatus): string {
    switch (value) {
      case SupportStatus.PENDING:
        return "Aberto";
      case SupportStatus.IN_PROGRESS:
        return "Em atendimento";
      case SupportStatus.FINISHED:
        return "Finalizado";
      case SupportStatus.CANCELED:
        return "Cancelado";
      default:
        return value;
    }
  }
}
